import { Typography } from "@mui/material";
import history from "utils/history";
import viewpaths from "global/constants/ViewPathConstants";
import FEATURE_UPGRADE_COPY from "global/constants/FeatureGateCopy";
import { AppModal, bodyTextSx } from "global/components/AppModal";

interface CustomProps {
  open: boolean;
  featureKey?: string;
  title?: string;
  message?: string;
  onClose: () => void;
}

const UpgradeModal = (props: CustomProps) => {
  const copy =
    (props.featureKey && FEATURE_UPGRADE_COPY[props.featureKey]) || undefined;
  const title = props.title ?? copy?.title ?? "Upgrade your plan";
  const message =
    props.message ??
    copy?.message ??
    "This feature is available on higher plans. Upgrade now to unlock it and get access to more powerful tools built for growing teams.";

  const handleUpgrade = () => {
    props.onClose();
    history.push(viewpaths.viewMyPlanViewPath);
  };

  return (
    <AppModal
      open={props.open}
      onClose={props.onClose}
      title={title}
      subtitle="Unlock more powerful features"
      // Tone default icon is the lock glyph — the same one the plan-limit
      // banner and locked-feature card use, so the "why am I blocked" signal
      // reads the same everywhere.
      tone="amber"
      size="sm"
      primaryLabel="Upgrade"
      onPrimary={handleUpgrade}
      cancelLabel="Maybe later"
      onCancel={props.onClose}
    >
      <Typography sx={bodyTextSx}>{message}</Typography>
    </AppModal>
  );
};

export default UpgradeModal;
